(ns teamoesterreich.admin-mode.can-you.can-you-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.date :as h-date]
            [reagent.core :as r]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)

            [teamoesterreich.admin-mode.ui-helper.sms-block-edit-card :as sms-block-edit-card]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.data.event :as s-events]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]))




(defn get-base [!actual-event disabled]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])
        !orgId (r/cursor !st [:data :crowdtaskerEvent-orgId])
        !list-loaded (r/cursor store/app-state [:event :canYou-list-state :loaded])
        ]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!actual-event key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!actual-event key))))
            has-changes? (or
                           (changed? :crowdtaskerEvent-name)
                           (changed? :crowdtaskerEvent-locationName)
                           (changed? :crowdtaskerEvent-acceptableUntil)
                           (changed? :crowdtaskerEvent-timeFrom)
                           (changed? :crowdtaskerEvent-timeTo)
                           (changed? :crowdtaskerEvent-orgId)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            acceptableUntil-date (h-date/parse-service-date! (or (:crowdtaskerEvent-acceptableUntil @!data) (:crowdtaskerEvent-acceptableUntil @!actual-event)))
            from-date (h-date/parse-service-date! (or (:crowdtaskerEvent-timeFrom @!data) (:crowdtaskerEvent-timeFrom @!actual-event)))
            to-date (h-date/parse-service-date! (or (:crowdtaskerEvent-timeTo @!data) (:crowdtaskerEvent-timeTo @!actual-event)))

            fromError (and from-date to-date (h-date/date>? from-date to-date))
            acceptableError (and acceptableUntil-date to-date (or (h-date/date>? acceptableUntil-date to-date)))
            toError (and from-date to-date (or (h-date/date>? from-date to-date)))

            ]

        (when (nil? @!orgId) (reset! !orgId (:crowdtaskerEvent-orgId @!actual-event)))

        [mui/card
         (log/debug "rerender form " @!orgId (clj->js @!data))
         [mui/card-header {:title "Anfrage Details"}]
         ;[mui/card-content [:span "test date " (h-date/parse-local-date (:crowdtaskerEvent-acceptableUntil @!actual-event))]]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }



           [mui/grid
            {:item  true
             :md    6
             :xs    12
             :style {:backgroundColor (if (changed? :crowdtaskerEvent-orgId) "#ffd6d2" "#ffffff")}
             }
            [(org-selector/get-org-selector !orgId (d-rights/get-rights-orgId-filter d-rights/CANYOU) {:longRow 1 :border "" :readonly (not @!edit-mode)})]
            ]

           [mui/grid
            {:item true
             :md   12
             :xs   12
             }]

           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-name @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-name (h/event-value e)))
                             :label        "Anfrage Name"}]
            ]

           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Anfrage Begin"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-timeFrom date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-timeFrom @!actual-event))
                             :error           fromError
                             :helperText      (if fromError "ungültig (muss vor Anfrage Ende sein)" "")
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-timeTo) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Anfrage Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-timeTo date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-timeTo @!actual-event))
                             :error           toError
                             :helperText      (if toError "ungültig (muss nach Anfrage Beginn & in der Zukunft sein)" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])
           (when (and (not @!edit-mode) disabled (d-rights/allow-admin-for d-rights/CANYOU_ACTIVATE (:crowdtaskerEvent-orgId @!actual-event)))
             [mui/button {
                          :variant   "outlined"
                          :style     {:color "orange"}
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten (superuser)"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :disabled  (and (not has-changes?) (not disabled))
                          :onClick   (fn []
                                       (reset! !edit-mode false)
                                       (reset! !data {}))

                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (or (not has-changes?) fromError toError acceptableError)
                          :onClick   (fn []
                                       (s-events/>event-save (:crowdtaskerEvent-uuid @!actual-event)
                                                             (merge @!data
                                                                    [:crowdtaskerEvent-orgId (if (and @!orgId (not= "" @!orgId)) @!orgId (first (d-rights/get-rights-orgId-filter d-rights/CANYOU)))])
                                                             (fn [data]
                                                               (reset! !actual-event data)
                                                               (reset! !list-loaded false)
                                                               )))
                          } "Speichern"])

           ]
          ]

         ]))))

(defn get-description [!actual-event disabled]              ;; push/SMS
  (let [!state (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-devices (r/cursor store/app-state [:user-devices])
        !show-send-me-push (r/cursor !state [:show-send-me-push])
        !show-send-me (r/cursor !state [:show-send-me])
        !su-edit (r/cursor !state [:su-edit])
        ]
    (fn []
      (log/debug "user PUSH" @!user-devices)
      (let [save-fn (fn [text]
                      (s-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-description text}
                                            (fn [data]
                                              (reset! !actual-event data)
                                              (reset! !su-edit false))))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [are-you-sure-modal/are-you-sure-modal !show-send-me-push
          "Möchtest du diese Anfrage-Push testweise an dich senden ?" "Senden"
          (fn [] (s-events/>event-send-test-alarm (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Anfrage-SMS testweise an dich senden ?" "Senden"
          (fn [] (s-events/>event-send-test-alarm (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         (if (and disabled (not @!su-edit))
           [:div {:style {:border "1px dotted darkgrey" :paddingBottom "10px"}}
            [:h3 "Anfrage (SMS/Push)"]
            [:div (get @!actual-event :crowdtaskerEvent-description)]
            (when (and disabled (d-rights/allow-admin-for d-rights/CANYOU_ACTIVATE (:crowdtaskerEvent-orgId @!actual-event)))
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])]
           [(sms-block-edit-card/get-it (get @!actual-event :crowdtaskerEvent-description) save-fn
                                        {:title              "Anfrage (SMS/Push)"
                                         :subText            "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#"
                                         :additional-buttons [:div
                                                              [mui/button {
                                                                           :variant   "contained"
                                                                           :color     "secondary"
                                                                           :startIcon (r/as-element [send])
                                                                           :onClick   #(reset! !show-send-me true)
                                                                           } "An mich per SMS"]
                                                              [mui/button {
                                                                           :style     {:marginLeft "10px"}
                                                                           :variant   "contained"
                                                                           :color     "secondary"
                                                                           :startIcon (r/as-element [send])
                                                                           :onClick   #(reset! !show-send-me-push true)
                                                                           } "An mich per Push"]]
                                         :on-cancel-fn       on-cancel-fn
                                         :template-group     "canYou"}
                                        )])

         ]
        ))))



(defn get-it [!actual-event disabled]
  [mui/card-content {}
   [(get-base !actual-event disabled)]
   [:br]
   [(get-description !actual-event disabled)]
   [:h3 "TODO sms Antworten hier konfigurieren"]
   ])